import axios from "axios"
import { Either, Left, array } from "purify-ts"
import { DriftskontraktTypeList } from "../components/Driftskontrakt/update"
import { PollData } from "@nvdb-rapport/shared/src/ApiData"
import qs from "qs"
import { VegobjektTypeList } from "../utils/vegobjekt"
import { ContractArea } from "../types"

const rapportHeaders = {
  "X-client": "NVDB-Rapporter-Frontend-Gammel",
}

const myHost = typeof window !== "undefined" ? window.location.href : ""
function contextualPath(): string {
  if (myHost.includes("localhost")) {
    return "http://localhost:8080/rapporter"
  } else if (
    myHost.includes("nvdb-vegnett-og-objektdata.utv.atlas.vegvesen.no")
  ) {
    return "https://nvdbrapportapi.utv.atlas.vegvesen.no/rapporter"
  } else if (
    myHost.includes("nvdb-vegnett-og-objektdata.test.atlas.vegvesen.no")
  ) {
    return "https://nvdbrapportapi.test.atlas.vegvesen.no/rapporter"
  } else if (myHost.includes("nvdb-vegnett-og-objektdata.atlas.vegvesen.no")) {
    return "https://nvdbrapportapi.atlas.vegvesen.no/rapporter"
  }
  return "http://localhost:8080/rapporter"
}
export const apiPath = contextualPath()

export async function fetchKontraktsomraader(): Promise<
  Either<string, ContractArea[]>
> {
  try {
    const response = await fetch(`${apiPath}/kontraktsomraader`, {
      headers: rapportHeaders,
    })
    const data = await response.json()

    return array(ContractArea).decode(data)
  } catch (e) {
    return Left("Innhenting av kontraktsområder fra NVDB API feilet")
  }
}

export type DriftskontraktQueryData = {
  kontraktsomradeId: number
  dato: string
  rapporttype?: number
  zip?: boolean
  spraak: string
  vegsystemreferanser: string[]
  vegobjekttyper?: number[]
  V4?: boolean
}

export type GeneriskQueryData = {
  kontraktsomradeId?: number
  dato: string
  fylke?: number[]
  kommune?: number[]
  rapporttype: number
  spraak: string
  vegsystemreferanser: string[]
  vegobjekttyper?: number[]
  V4?: boolean
}

export async function requestDriftskontraktReport(
  query: DriftskontraktQueryData
): Promise<Either<string, PollData>> {
  const response = await axios.get(`${apiPath}/driftskontrakt`, {
    headers: rapportHeaders,
    params: query,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  })
  return PollData.decode(response.data)
}

export async function requestZipArchive(
  query: DriftskontraktQueryData
): Promise<Either<string, PollData>> {
  const response = await axios.get(`${apiPath}/kontraktZip`, {
    headers: rapportHeaders,
    params: query,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  })
  return PollData.decode(response.data)
}

export async function fetchDriftskontraktstyperIO(): Promise<
  Either<string, DriftskontraktTypeList>
> {
  try {
    const response = await axios.get(`${apiPath}/driftskontraktrapporttyper`, {
      headers: rapportHeaders,
    })
    const data = response.data
    return DriftskontraktTypeList.decode(data)
  } catch (e) {
    return Left(e)
  }
}

export async function requestGeneriskReport(
  query: GeneriskQueryData
): Promise<Either<string, PollData>> {
  const response = await axios.get(`${apiPath}/driftskontrakt`, {
    headers: rapportHeaders,
    params: query,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  })
  return PollData.decode(response.data)
}

export async function fetchVegobjectTyperTilvalg(
  rapporttypeId: number
): Promise<Either<string, VegobjektTypeList>> {
  try {
    const response = await axios.get(
      `${apiPath}/driftskontraktvegobjekttyper/tilvalg/${rapporttypeId}`,
      { headers: rapportHeaders }
    )
    return VegobjektTypeList.decode(response.data)
  } catch (e) {
    return Left(
      `Nettverksfeil ved innhenting av objekttyper (fetchVegobjectTyper): ${e}`
    )
  }
}

export async function fetchVegobjectTyperDefault(
  rapporttypeId: number
): Promise<Either<string, VegobjektTypeList>> {
  try {
    const response = await axios.get(
      `${apiPath}/driftskontraktvegobjekttyper/default/${rapporttypeId}`,
      { headers: rapportHeaders }
    )
    return VegobjektTypeList.decode(response.data)
  } catch (e) {
    return Left(
      `Nettverksfeil ved innhenting av objekttyper (fetchVegobjectTyper): ${e}`
    )
  }
}

export async function pollContract(
  id: string
): Promise<Either<string, PollData>> {
  try {
    const response = await axios.get(`${apiPath}/poll/${id}`, {
      headers: rapportHeaders,
    })

    return PollData.decode(response.data)
  } catch (e) {
    return Left(e)
  }
}

export function downloadContractLink(filnavn: string, filtype: string): string {
  return `${apiPath}/nedlasting/${filnavn}?filtype=${filtype}`
}
